import { render, staticRenderFns } from "./deleteAccount.vue?vue&type=template&id=21323a39&scoped=true&"
import script from "./deleteAccount.vue?vue&type=script&lang=js&"
export * from "./deleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./deleteAccount.vue?vue&type=style&index=0&id=21323a39&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21323a39",
  null
  
)

export default component.exports